<template>
  <div name="uploadtv">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">影片詳情</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">影音</li>
              <li class="breadcrumb-item">
                <a href="/admin/tv">Soonnet TV 列表</a>
              </li>
              <li class="breadcrumb-item active">影片詳情</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-md-8 col-sm-12">
            <div class="card card-primary">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-4">
                    <!-- Video Image -->
                    <div class="b-video-thumbnail w-100">
                      <div>
                        <div class="pic_img">
                          <div>
                            <p class="type_title">
                              <i style="color: red">*</i>
                              <span>影片封面上傳（只支援jpg格式）</span>
                            </p>
                            <el-upload
                              style="
                                border: 1px solid #dcdfe6;
                                margin-right: 37px;
                              "
                              :action="
                                uploadImageUrl + '&id=' + this.user.userId
                              "
                              :show-file-list="false"
                              :on-success="handleAvatarSuccess"
                              :before-upload="beforeAvatarUpload"
                            >
                              <img
                                v-if="imageUrl"
                                :src="imageUrl"
                                style="width: 305px"
                              />
                              <i
                                v-else
                                class="el-icon-plus avatar-uploader-icon"
                              ></i>
                            </el-upload>
                          </div>
                          <div class="pic_img_box">
                            <p class="type_title">
                              <i style="color: red">*</i>
                              <span>影片上傳（只支援mp4格式）</span>
                            </p>

                            <el-upload
                              ref="upload"
                              :auto-upload="false"
                              class="upload-demo"
                              :on-remove="videoremove"
                              :on-change="videoSaveToUrl"
                              :file-list="fileList"
                              :action="uploadUrl + '?id=' + this.user.userId"
                              :limit="1"
                            >
                              <el-progress
                                v-if="videoFlag == true"
                                :percentage="videoUploadPercent"
                              ></el-progress>
                              <el-button
                                slot="trigger"
                                size="small"
                                type="primary"
                                >选取文件</el-button
                              >
                              <el-button
                                size="small"
                                type="success"
                                :disabled="uploadimagebtn"
                                @click="submitUpload"
                                >上传到服务器</el-button
                              >
                              <el-button
                                size="small"
                                type="danger"
                                v-if="errmsg"
                                @click="submitUpload"
                                >重新上傳</el-button
                              >
                            </el-upload>
                            <video
                              v-if="videoForm.showVideoPath != '' && !videoFlag"
                              v-bind:src="videoForm.showVideoPath"
                              class="avatar video-avatar"
                              controls="controls"
                              style="width: 305px"
                            >
                              您的浏览器不支持视频播放
                            </video>
                            <span v-if="errmsg" style="color: red"
                              >上傳失败{{ this.updateError }}</span
                            >
                            <!-- <el-upload
                              class="avatar-uploader"
                              style="border: 1px solid #dcdfe6;margin-right:37px"
                              :action="uploadUrl+'?id='+this
                              .user.userId"
                              :headers="getHeaders"
                              v-bind:on-progress="uploadVideoProcess"
                              v-bind:on-success="handleVideoSuccess"
                              v-bind:on-error="handleVideoError"
                              v-bind:before-upload="beforeUploadVideo"
                              v-bind:show-file-list="false"
                            >
                              <video
                                v-if="videoForm.showVideoPath !='' && !videoFlag"
                                v-bind:src="videoForm.showVideoPath"
                                class="avatar video-avatar"
                                controls="controls"
                                style="width:305px"
                              >您的浏览器不支持视频播放</video>
                              <i
                                v-else-if="videoForm.showVideoPath =='' && !videoFlag"
                                class="el-icon-plus avatar-uploader-icon"
                              ></i>
                              <el-progress
                                v-if="videoFlag == true"
                                type="circle"
                                v-bind:percentage="videoUploadPercent"
                                style="margin-top:7px;"
                              ></el-progress>
                            </el-upload>-->
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.Video Image -->
                    <dl class="row mt-3">
                      <dt
                        class="col-sm-3"
                        v-if="
                          this.videoForm.name != null &&
                          this.videoForm.name != ''
                        "
                      >
                        檔案名稱
                      </dt>
                      <dd
                        class="col-sm-9"
                        v-if="
                          this.videoForm.name != null &&
                          this.videoForm.name != ''
                        "
                      >
                        {{ this.videoForm.name }}
                      </dd>
                      <dt class="col-sm-3">檔案大小</dt>
                      <dd class="col-sm-9">{{ this.videoForm.size }}</dd>
                      <dt class="col-sm-3">上傳者</dt>
                      <dd class="col-sm-9">{{ this.videoForm.user }}</dd>
                      <dt class="col-sm-3">上傳時間</dt>
                      <dd class="col-sm-9">{{ this.videoForm.createTime }}</dd>
                    </dl>
                  </div>
                  <div class="col-sm-8">
                    <el-form
                      :model="TVModel"
                      ref="TVModel"
                      :rules="rules"
                      label-width="120px"
                    >
                      <el-form-item label="關聯節目">
                        <el-select
                          v-model="TVModel.program"
                          placeholder="無數據"
                        >
                          <el-option label="請選擇" value="-1"></el-option>
                          <el-option
                            v-for="item in programList"
                            v-bind:key="item.id"
                            :value="item.id"
                            :label="item.sgL_Program_Name"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="影片標題" prop="videoTitle">
                        <el-input v-model="TVModel.videoTitle"></el-input>
                      </el-form-item>
                      <el-form-item label="影片描述">
                        <el-input
                          type="textarea"
                          rows="4"
                          v-model="TVModel.description"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="影片集數">
                        <el-input-number
                          v-model="TVModel.sgL_NumberNo"
                        ></el-input-number>
                      </el-form-item>
                      <el-form-item label="關鍵字">
                        <el-input
                          v-model="TVModel.keysWorld"
                          placeholder="(以 ',' 作分隔，不需加上空格，e.g. 賽事報導,路跑,渣打馬拉松)"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="影片分類" prop="videoType">
                        <el-select
                          v-model="TVModel.videoType"
                          placeholder="請選擇類型"
                        >
                          <el-option label="SOONNET TV" value="256"></el-option>
                          <!-- <el-option
                            v-for="vtype in videoTypeList"
                            :key="vtype.id"
                            :value="vtype.id"
                            :label="vtype.sgL_Type_Name"
                          ></el-option>-->
                        </el-select>
                      </el-form-item>
                      <el-form-item label="拍攝日期">
                        <el-date-picker
                          type="date"
                          placeholder="請選擇日期"
                          v-model="TVModel.pictureDate"
                        ></el-date-picker>
                      </el-form-item>
                      <el-form-item label="公開狀態" prop="status">
                        <el-select
                          v-model="TVModel.status"
                          placeholder="請選擇狀態"
                        >
                          <el-option
                            v-for="status in initData.statusList"
                            :key="status.key"
                            :value="status.key"
                            :label="status.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <el-input v-model="TVModel.Id" type="hidden"></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-button
                          type="primary"
                          :disabled="subbtn"
                          @click="submitForm('TVModel')"
                          >保存</el-button
                        >
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapAction } from "vuex";
import { Message } from "element-ui";
import base from "../../api/httpApi/base";
import axios from "../../api/httpApi/http";
import fileupload from "../../assets/backJs/util";
export default {
  name: "upload",
  data() {
    return {
      getHeaders: {
        Accept: "application/json",
      },
      num: 1,
      updateError: "",
      subbtn: false,
      errmsg: false,
      fileList: [],
      user: {}, //上传视频时需要带上用户id
      imageUrl: "", //图片显示地址
      uploadVideo: null, //视频本体
      uploadId: "", //图片上传后返回来的图片ID
      uploadVideoId: "", //视频上传后返回来的视频ID
      uploadimagebtn: false, //上传图片的按钮是否可点击
      uploadImageUrl: `${base.dev}/TokenAuth/UploadImg/Upload/FormImg?Type=video`,
      // "https://api.soonnet.org/api/TokenAuth/UploadImg/Upload/FormImg?Type=video",
      // "http://210.21.243.82:47097/api/TokenAuth/UploadImg/Upload/FormImg?Type=video", //图片上传地址
      // "http://172.16.3.61:21021/api/TokenAuth/UploadImg/Upload/FormImg?Type=video",
      uploadUrl: `${base.dev}/TokenAuth/Upload`, //"https://api.soonnet.org/api/TokenAuth/Upload", //视频上传地址 //"http://210.21.243.82:47097/api/TokenAuth/Upload","https://api.soonnet.org/api/TokenAuth/Upload"
      videoFlag: false,
      //是否显示进度条
      videoUploadPercent: 0,
      //进度条的进度，
      isShowUploadVideo: false,
      //显示上传按钮
      videoForm: {
        showVideoPath: "", //显示已上传视频地址
        name: "",
        size: "",
        user: "",
        createTime: "",
      },
      initData: {
        statusList: [
          { key: 1, value: "顯示" },
          { key: 0, value: "隱藏" },
        ],
      },
      TVModel: {
        Id: "",
        program: "-1",
        videoTitle: "",
        sgL_NumberNo: undefined,
        description: "",
        keysWorld: "",
        videoType: "",
        pictureDate: "",
        status: 1,
        ImageId: "",
        VideoId: "",
        TimeSize: 0,
        widthAndHeight: "",
        tVSize: 0,
      },
      rules: {
        videoTitle: [
          { required: true, message: "請輸入影片標題", trigger: "blur" },
          {
            min: 2,
            max: 100,
            message: "長度在 2 到 100 個字符",
            trigger: "blur",
          },
        ],
        status: [{ required: true, message: "請選擇狀態", trigger: "change" }],
        // sgL_NumberNo: [
        //   {
        //     type: "number",
        //     required: true,
        //     message: "請輸入集數",
        //     triggle: "blur",
        //   },
        // ],
        videoType: [
          { required: true, message: "請選擇影片類型", trigger: "change" },
        ],
        pictureDate: [
          {
            type: "date",
            required: true,
            message: "請選擇日期",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    //判断是否为修改
    this.TVModel.Id = this.$route.query.Id;
    if (this.TVModel.Id != undefined && this.TVModel.Id != "") {
      //修改，查询此id的信息
      this.getById(this.TVModel.Id);
    }
    //从store中读取user数据
    this.user = this.$store.getters.getUser;
    this.videoForm.user = this.user.displayName;
  },
  beforeMount() {
    let admin = this.$store.getters.getAdminUser;
    let permission = this.$store.getters.getPermission;
    if (admin == null || permission.Istoken == false) {
      this.$router.push("/login");
    }
  },
  watch: {},
  methods: {
    //添加影片
    submitForm(formName) {
      if (this.uploadId == "" || this.uploadVideoId == "") {
        Message({
          type: "error",
          message: "請上傳視頻及封面圖片",
        });
        return false;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.subbtn = true;
          let params = {
            movieId: this.uploadVideoId, //视频id
            imageId: this.uploadId, //图片id
            timeSize: this.TVModel.timeSize,
            tVSize: (this.TVModel.tVSize + "").replace(".",","),
            widthAndHeight: this.TVModel.widthAndHeight,
            sgL_NumberNo: this.TVModel.sgL_NumberNo,
            relevanceId: this.TVModel.program, //节目id
            title: this.TVModel.videoTitle, //标题
            remark: this.TVModel.description, //描述
            keysWorld: this.TVModel.keysWorld, //关键字
            categoryId: this.TVModel.videoType, //影片分类id
            createDateTime: this.TVModel.pictureDate, //拍摄时间
            isShow: this.TVModel.status,
          };
          if (this.TVModel.program == null) {
            params.relevanceId = 0;
          }
          if (this.TVModel.Id != null && this.TVModel.Id != "") {
            //修改
            params.Id = this.TVModel.Id;
            this.$api.VideoApi.AdmineditMovie(params).then((res) => {
              if (res.data.success) {
                Message({
                  type: "success",
                  message: "修改成功",
                });
                this.$router.push({ name: "TVList" });
              } else {
                Message({
                  type: "error",
                  message: "修改失敗",
                });
              }
            });
          } else {
            this.$api.VideoApi.AdminAddMovie(params).then((result) => {
              if (result.data.success) {
                Message({
                  type: "success",
                  message: "上傳成功",
                });
                this.$router.push({ name: "TVList" });
              } else {
                Message({
                  type: "error",
                  message: "上傳失敗",
                });
              }
            });
          }
        } else {
          Message({
            type: "error",
            message: "請填寫必填數據",
          });
          return false;
        }
      });
    },

    //根据id查询影片信息
    async getById(Id) {
      let params = { Id: Id };
      this.$api.VideoApi.AdminMoiveGet(params).then((res) => {
        if (res.data.success) {
          let model = res.data.result;
          this.TVModel.Id = model.id;
          this.TVModel.sgL_NumberNo = model.sgL_NumberNo;
          this.TVModel.program = model.relevanceId;
          this.TVModel.videoType = "256";
          this.TVModel.pictureDate = model.sgL_Mov_VAddTimer;
          this.TVModel.status = model.isShow;
          this.TVModel.videoTitle = model.sgL_Mov_VSubject;
          this.TVModel.description = model.sgL_Mov_VDirections;
          this.TVModel.keysWorld = model.sgL_Mov_VKeyword;
          this.TVModel.widthAndHeight = model.sgL_Mov_VSourceScreen;
          //图片视频相关
          this.imageUrl = model.imageFile;
          this.videoForm.showVideoPath = model.movieFile;
          this.uploadVideoId = model.movieId;
          this.uploadId = model.imageId;
          this.videoForm.user = model.sgL_Mem_DisplayName;
          this.videoForm.size = model.sgL_Mov_VSourceSizeF;
          this.TVModel.tVSize = (model.sgL_Mov_VSourceSize / 1024 / 1024).toFixed(2);
          this.videoForm.createTime = model.sgL_Mov_VAddTimerF;
        }
      });
    },
    //#region 上传视频
    //上传成功回调
    handleVideoSuccess(res, file) {
      this.isShowUploadVideo = true;
      this.videoFlag = false;
      this.videoUploadPercent = 0;
      //后台上传地址
      if (res.success == false) {
        Message({
          type: "error",
          message: "上傳失敗",
        });
        return;
      } else {
        this.uploadVideoId = res.result.uploadId; //给视频id赋值
        this.videoForm.showVideoPath = res.result.url; //用于页面展示当前上传成功的视频地址
        this.videoForm.createTime = res.result.createTime;
        Message({
          type: "success",
          message: "上传成功",
        });
      }
    },
    handleVideoError(err, file) {
      console.log(err);
      this.videoFlag = false;
      this.videoUploadPercent = "";
      Message({
        type: "error",
        message: "當前網絡慢，請重試!",
      });
    },
    //#region 分片上传
    submitUpload() {
      this.videoFlag = true; //是否显示进度条
      this.uploadimagebtn = true; //是否禁用上传按钮
      fileupload.uploadFile(
        this.uploadVideo, //视频文件
        this.user.accessToken, //权限token
        this.user.userId,
        (uploadsuccess) => {
          //上传成功的函数
          this.uploadunite(uploadsuccess);
        },
        (successfile) => {
          //分片、視頻已存在直接返回地址，告訴用戶上傳成功
          this.videoFlag = false; //是否显示进度条
          this.uploadimagebtn = false;
          this.isShowUploadVideo = true;
          this.videoUploadPercent = 0; //进度条数据
          this.uploadVideoId = successfile.result.uploadId; //给视频id赋值
          this.videoForm.showVideoPath = successfile.result.url; //用于页面展示当前上传成功的视频地址
          this.videoForm.createTime = successfile.result.createTime;
          this.errmsg = false;
          Message({
            type: "success",
            message: "上傳成功",
          });
        },
        (process) => {
          //进度回调函数
          this.videoUploadPercent = process.toFixed(0) * 1;
        },
        (failePage) => {
          //分片上傳時如果服務斷掉會進入這裏
          Message({
            type: "error",
            message: failePage,
          });
          this.updateError = "，請檢查網絡！";
          this.errmsg = true;
          this.videoFlag = false;
          this.uploadimagebtn = false;
          this.fileList = [];
          this.videoUploadPercent = 0;
        }
      );

      // this.$refs.upload.submit();
    },
    videoremove(event) {
      //终止上传  to do
      this.videoFlag = false;
      this.uploadimagebtn = false;
      this.videoForm.showVideoPath = ""; //用于页面展示当前上传成功的视频地址
      this.videoForm.createTime = "";
      this.videoForm.name = "";
      this.videoForm.size = "";
    },
    videoSaveToUrl(event) {
      if (
        [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb",
          "video/mov",
        ].indexOf(event.raw.type) == -1
      ) {
        Message({
          type: "warning",
          message: "请上传正确的视频格式",
        });
        this.fileList = [];
        return false;
      }
      this.getVideoMsg(event.raw).then((res) => {
        console.log(res);
        this.TVModel.timeSize = res.duration;
        this.TVModel.widthAndHeight = res.width + "X" + res.height;
      });
      this.uploadVideo = event.raw;
      this.videoForm.name = this.uploadVideo.name;
      this.videoForm.size = (this.uploadVideo.size / 1024 / 1024).toFixed(2);
      this.TVModel.tVSize = this.videoForm.size;
    },
    getVideoMsg(file) {
      return new Promise((resolve) => {
        let videoElement = document.createElement("video");
        videoElement.src = URL.createObjectURL(file);
        videoElement.addEventListener("loadedmetadata", function () {
          resolve({
            duration: videoElement.duration,
            height: videoElement.videoHeight,
            width: videoElement.videoWidth,
          });
        });
      });
    },

    uploadunite(uploadsuccess) {
      //合并
      this.$api.VideoApi.uploadfileGather(uploadsuccess)
        .then((res) => {
          this.videoFlag = false;
          this.uploadimagebtn = false;
          this.videoUploadPercent = 0;
          if (res.data.success == false) {
            this.isShowUploadVideo = false;
            Message({
              type: "error",
              message: res.data.error.message,
            });
            this.updateError = "，合并視頻失敗," + res.data.error.message;
            this.errmsg = true;
          } else {
            this.isShowUploadVideo = true;
            this.videoFlag = false; //是否显示进度条
            this.uploadimagebtn = false;
            this.videoUploadPercent = 0; //进度条数据
            this.uploadVideoId = res.data.result.uploadId; //给视频id赋值
            this.videoForm.showVideoPath = res.data.result.url; //用于页面展示当前上传成功的视频地址
            this.videoForm.createTime = res.data.result.createTime;
            this.errmsg = false;
            this.num = 0;
            Message({
              type: "success",
              message: "上傳成功",
            });
          }
        })
        .catch((error) => {
          //請求失敗攔截
          if (this.num < 4) {
            setTimeout(() => {
              this.uploadunite(uploadsuccess);
              this.num++;
            }, 30000);
          }
        });
    },
    //#endregion
    //上传前回调
    beforeUploadVideo(file) {
      var value = file.size / 1024 / 1024;
      var fileSize = value < 10000;
      this.videoForm.size = parseFloat(value).toFixed(2) + "MB";

      this.videoForm.name = file.name;
      if (
        [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb",
          "video/mov",
        ].indexOf(file.type) == -1
      ) {
        Message({
          type: "warning",
          message: "请上传正确的视频格式",
        });
        // layer.msg("请上传正确的视频格式");
        return false;
      }
      if (!fileSize) {
        Message({
          type: "warning",
          message: "视频大小不能超过10G",
        });
        // layer.msg("");
        return false;
      }
      this.isShowUploadVideo = false;
    },
    //进度条
    uploadVideoProcess(event, file, fileList) {
      console.log("进度条进度" + file.percentage);
      this.videoFlag = true;
      this.videoUploadPercent = file.percentage.toFixed(0) * 1;
    },
    //#endregion

    //#region 上传图片
    handleAvatarSuccess(res, file) {
      this.uploadId = res.result.uploadId;
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const ispng = file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !ispng) {
        this.$message.error("上传封面图片只能是 JPG /png格式!");
      }
      if (!isLt5M) {
        this.$message.error("上传封面图片大小不能超过 5MB!");
      }
      return (isJPG || ispng) && isLt5M;
    },
    //#endregion
  },
  computed: {
    //store获取影片的分类
    ...mapGetters({ videoTypeList: "getVideoCategorygetters" }),
    //store获取sonnest  tv 所屬節目
    ...mapGetters({ programList: "getTvCategorygetters" }),
  },
};
</script>
<style scoped>
.avatar-uploader .el-upload {
  display: inherit;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminVideo/uploadTV.vue